<div class="modal" [class.is-active]="isOpen()">
    <div class="modal-background" (click)="closeModal()"></div>
    <div class="modal-card">
        <header class="modal-card-head">
            <div class="is-flex-grow-1">
                <div class="mb-2 is-flex is-align-items-center is-gap-2">
                    <div [class]="notification().priority | notificationTypeIconBackgroundPipe"
                        class="is-flex is-justify-content-center is-align-items-center"
                        style="height: 40px; width: 40px; border-radius: 8px; flex-shrink: 0;">
                        <div class="icon">
                            <i [class]="notification().type | notificationTypeIconPipe" class="has-text-white"
                                style="font-size: 1em;"></i>
                        </div>
                    </div>
                    <div>
                        <div class="modal-card-title mb-1">
                            {{ notification().title }}
                        </div>
                        <div class="is-size-7 has-text-grey">
                            <p>
                                {{ 'NotificationType.' + notification().type | translate | uppercase }} &middot;
                                {{ notification().createdAt | appDate }}
                                @if(notification().expiresAt) {
                                &middot; Expires: {{ notification().expiresAt | appDate }}
                                }
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <button class="delete" aria-label="close" (click)="closeModal()"></button>
        </header>
        <section class="modal-card-body">
            <div class="notification-body-content" [innerHTML]="sanitizeHtml(notification()!.body)"></div>
            
            @if(notification().organizations && notification().organizations.length > 0) {
            <div class="mt-5 pt-5" style="border-top: 1px solid #e8e8e8;">
                <h4 class="subtitle is-6 mb-3">Targeted Organizations</h4>
                <div class="is-flex is-flex-wrap-wrap is-gap-2">
                    @for(org of notification().organizations; track org.id) {
                    <span class="tag is-info">{{ org.name }}</span>
                    }
                </div>
            </div>
            }
        </section>
        <footer class="modal-card-foot is-justify-content-flex-end">
        </footer>
    </div>
</div>